import React from "react";
import Context from "../../../Context";
import Blocker from "../Blocker";
export default class CommentsForm extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      comment: {},
    };
  }

  componentDidMount() {
    this.resetComment();
  }

  resetComment = () => {
    this.setState({
      comment: {
        text: "",
      },
    });
  };

  onChange = (id, value) => {
    this.setState((state) => {
      let { comment } = state;
      comment[id] = value;
      return { comment };
    });
  };

  save = async () => {
    const { objectId } = this.props;
    const { comment } = this.state;
    let reply = this.props.reply || {};

    if (objectId && comment.text) {
      this.setState({ pending: true });
      let result = await this.context.api.q("/comment/set", {
        object: objectId,
        text: comment.text,
        parent: reply.id || null,
      });
      this.setState({ pending: false });
      if (result !== false) {
        this.context.toast("Изменения сохранены", "success");

        this.resetComment();
        if (this.props.onAfterSave) {
          this.props.onAfterSave(result);
        }
      } else {
        this.context.toast("Не удалось сохранить изменения", "error");
      }
    }
  };

  render() {
    const { comment, pending } = this.state;
    let reply = this.props.reply || {};
    let replyDate = reply.created ? new Date(reply.created) : {};
    return (
      <>
        <Blocker on={this.props.parentPending}>
          <div className="pb-4 mb-4 border-bottom">
            {reply.id && (
              <div className="mb-2 p-2 bg-light-primary">
                В ответ на: <span className="text-primary">{reply.name}</span>{" "}
                <span className="small text-dark-50">
                  {replyDate.toLocaleString()}
                </span>
                <i
                  title="Не отвечать"
                  className="fa fa-times text-hover-primary cursor-pointer ml-2"
                  onClick={() => this.props.onReply({})}
                ></i>
              </div>
            )}
            <textarea
              placeholder="Ваш комментарий"
              onChange={(e) => this.onChange("text", e.target.value)}
              className="form-control"
              value={comment.text || ""}
            />
            <div className="mt-2 text-right">
              <button
                onClick={this.save}
                className={`btn btn-primary ${!comment.text && "disabled"} ${
                  pending && "spinner"
                } spinner-white spinner-right`}
              >
                Отправить
              </button>
            </div>
          </div>
        </Blocker>
      </>
    );
  }
}
